// Pembanding rekursif dua objek summary. Sengaja nol import supaya bisa
// dijalanin langsung pakai node (lihat summaryDiff.check.mjs).

function isPlainObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

function joinPath(basePath, key) {
  return basePath ? `${basePath}.${key}` : key;
}

// Bandingin `newValue` (endpoint baru) sama `oldValue` (endpoint lama) sampai
// ke nilai daun. `comparedLeaves` dilaporin balik sebagai penjaga: diff yang
// diem-diem ngelewatin objek bersarang bakal keliatan dari angka ini yang
// kekecilan, bukan dari hasilnya yang keliatan bersih.
export function deepDiff(newValue, oldValue, basePath = '') {
  const findings = [];
  let comparedLeaves = 0;

  const walk = (a, b, path) => {
    if (isPlainObject(a) && isPlainObject(b)) {
      const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
      keys.forEach((key) => {
        const childPath = joinPath(path, key);
        if (!(key in b)) {
          findings.push({ path: childPath, kind: 'onlyInNew', newValue: a[key] });
        } else if (!(key in a)) {
          findings.push({ path: childPath, kind: 'onlyInOld', oldValue: b[key] });
        } else {
          walk(a[key], b[key], childPath);
        }
      });
      return;
    }

    comparedLeaves += 1;

    if (typeof a === 'number' && typeof b === 'number') {
      if (Number.isNaN(a) && Number.isNaN(b)) return;
      if (Number.isNaN(a) || Number.isNaN(b)) {
        findings.push({
          path, kind: 'value', newValue: a, oldValue: b, pct: null, severity: 'major',
        });
        return;
      }
      if (a === b) return;
      const pct = b === 0 ? null : ((a - b) / b) * 100;
      const severity = pct === null || Math.abs(pct) > 1 ? 'major' : 'minor';
      findings.push({
        path, kind: 'value', newValue: a, oldValue: b, pct, severity,
      });
      return;
    }

    if (JSON.stringify(a) !== JSON.stringify(b)) {
      findings.push({
        path, kind: 'value', newValue: a, oldValue: b, pct: null, severity: 'major',
      });
    }
  };

  walk(newValue, oldValue, basePath);
  return { findings, comparedLeaves };
}

export default deepDiff;
